<template>
  <div class="dashboard">
    <!-- HEADER -->
    <div class="header">
      <h1>Aperçu des nœuds</h1>
      <span>Dernière mise à jour : {{ time }}</span>
    </div>

    <!-- STATS -->
    <div class="stats">
      <div class="stat">
        <h2>{{ nodes.length }}</h2>
        <p>Nœuds total</p>
      </div>
      <div class="stat">
        <h2>{{ runningCount }}</h2>
        <p>Actifs</p>
      </div>
      <div class="stat">
        <h2>{{ loadingCount }}</h2>
        <p>Démarrage</p>
      </div>
      <div class="stat">
        <h2>{{ stoppedCount }}</h2>
        <p>Arrêtés</p>
      </div>
    </div>

    <!-- GRID -->
    <div class="grid">
      <div v-for="node in nodes" :key="node.id" class="card">
        <div class="card-header">
          <span :class="['dot', node.status]"></span>
          <h3>{{ node.name }}</h3>
        </div>

        <p class="status-text">{{ label(node.status) }}</p>

        <div class="metrics">
          <span>CPU {{ node.cpu }}%</span>
          <span>RAM {{ node.ram }}%</span>
        </div>

        <div class="graph">
          <div
            v-for="i in 20"
            :key="i"
            class="bar"
            :style="{ height: randomHeight() + 'px' }"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'

const nodes = ref(
  Array.from({ length: 15 }, (_, i) => ({
    id: i,
    name: `Node-${(i + 1).toString().padStart(2, '0')}`,
    status: 'running',
    cpu: 20,
    ram: 40
  }))
)

const time = ref(new Date().toLocaleTimeString())

const randomize = () => {
  nodes.value.forEach(n => {
    const r = Math.random()
    n.status = r > 0.8 ? 'stopped' : r > 0.6 ? 'loading' : 'running'
    n.cpu = Math.floor(Math.random() * 60)
    n.ram = Math.floor(Math.random() * 70)
  })
  time.value = new Date().toLocaleTimeString()
}

onMounted(() => {
  setInterval(randomize, 2000)
})

const runningCount = computed(() =>
  nodes.value.filter(n => n.status === 'running').length
)
const loadingCount = computed(() =>
  nodes.value.filter(n => n.status === 'loading').length
)
const stoppedCount = computed(() =>
  nodes.value.filter(n => n.status === 'stopped').length
)

const label = s =>
  s === 'running' ? 'En ligne' :
  s === 'loading' ? 'Démarrage...' :
  'Arrêté'

const randomHeight = () => Math.random() * 30 + 5
</script>

<style>
body {
  margin: 0;
  font-family: Arial;
  background: #0f172a;
  color: white;
}

.dashboard {
  padding: 20px;
}

.header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

.stats {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
  margin-bottom: 20px;
}

.stat {
  background: #1e293b;
  padding: 15px;
  border-radius: 10px;
  text-align: center;
}

.grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 15px;
}

.card {
  background: #1e293b;
  border-radius: 12px;
  padding: 15px;
}

.card-header {
  display: flex;
  align-items: center;
  gap: 8px;
}

.dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
}

.running { background: #22c55e; }
.loading {
  background: #facc15;
  animation: blink 1s infinite;
}
.stopped { background: #ef4444; }

@keyframes blink {
  50% { opacity: 0.3; }
}

.status-text {
  margin: 5px 0 10px;
  font-size: 0.9em;
}

.metrics {
  display: flex;
  justify-content: space-between;
  font-size: 0.8em;
}

.graph {
  display: flex;
  align-items: flex-end;
  gap: 2px;
  height: 40px;
  margin-top: 10px;
}

.bar {
  width: 3px;
  background: #22c55e;
}
</style>